import { Pipe, PipeTransform } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { LsqListSource } from '@lsq-frontend/angular-shared/api-service';

@Pipe({
    name: 'asListSource',
    pure: false
})
export class AsListSourcePipe<DataType = any> implements PipeTransform {
    private _listSource: LsqListSource<DataType>;
    private _rowsSubject = new ReplaySubject<DataType[]>(1);

    public transform(value: DataType[]): LsqListSource<DataType> {
        if (!this._listSource) {
            this._listSource = new LsqListSource({
                rows$: this._rowsSubject.asObservable().pipe(distinctUntilChanged())
            });
        }
        this._rowsSubject.next(value);
        return this._listSource;
    }
}
